import { createShiftJsonClient } from '../http/shift-json-client';
import type { ShiftEmployeeSchedulingDirectory, ShiftEmployeeSchedulingDetail, ShiftEmployeeSchedulingPatch } from 'shared-models';
import type { ShiftAccountDirectory, ShiftAccountPatch, ShiftAccountState } from 'shared-models';
import type {
  ShiftEmployeeDirectoryManagerRow,
  ShiftEmployeeCreateInput,
  ShiftEmployeeDirectoryWorkerRow,
  ShiftEmployeeSelfProfile,
  ShiftSectionSummary,
  ShiftEmployeeUpdateInput,
} from '../../models/employees.types';

const requestJson = createShiftJsonClient('אין תקשורת לשרת. ודאו שה-backend רץ על http://localhost:5000.');

class ShiftEmployeesService {
  async listAccounts(offset=0,state:ShiftAccountState | 'all'='all'):Promise<ShiftAccountDirectory> {
    return requestJson(`/shift/employees/accounts?offset=${offset}&limit=25&state=${state}`,{method:'GET'});
  }

  async patchAccount(id:number,patch:ShiftAccountPatch):Promise<void> {
    await requestJson(`/shift/employees/accounts/${id}`,{method:'PATCH',body:JSON.stringify(patch)});
  }
  async listScheduling(offset = 0): Promise<ShiftEmployeeSchedulingDirectory> {
    return requestJson(`/shift/employees/scheduling?offset=${offset}&limit=25`, { method: 'GET' });
  }

  async getScheduling(employeePk: number, offset = 0, weekStart?: string): Promise<ShiftEmployeeSchedulingDetail> {
    return requestJson(`/shift/employees/${employeePk}/scheduling?offset=${offset}&limit=25${weekStart ? `&weekStart=${encodeURIComponent(weekStart)}` : ''}`, { method: 'GET' });
  }

  async patchScheduling(employeePk: number, patch: ShiftEmployeeSchedulingPatch): Promise<void> {
    await requestJson(`/shift/employees/${employeePk}/scheduling`, { method: 'PATCH', body: JSON.stringify(patch) });
  }

  async listSections(): Promise<ShiftSectionSummary[]> {
    return requestJson<ShiftSectionSummary[]>('/shift/sections', {
      method: 'GET',
    });
  }

  async listDirectory(): Promise<Array<ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow>> {
    return requestJson<Array<ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow>>(
      '/shift/employees',
      {
        method: 'GET',
      },
    );
  }

  async createEmployee(payload: ShiftEmployeeCreateInput): Promise<ShiftEmployeeDirectoryManagerRow> {
    return requestJson<ShiftEmployeeDirectoryManagerRow>('/shift/employees', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async getEmployeeDetails(
    employeePk: number,
  ): Promise<ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow> {
    return requestJson<ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow>(
      `/shift/employees/${employeePk}`,
      {
        method: 'GET',
      },
    );
  }

  async updateEmployee(
    employeePk: number,
    payload: ShiftEmployeeUpdateInput,
  ): Promise<ShiftEmployeeDirectoryManagerRow> {
    return requestJson<ShiftEmployeeDirectoryManagerRow>(`/shift/employees/${employeePk}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }

  async getMyProfile(): Promise<ShiftEmployeeSelfProfile> {
    return requestJson<ShiftEmployeeSelfProfile>('/shift/employees/me', {
      method: 'GET',
    });
  }

  async updateMyProfile(payload: ShiftEmployeeUpdateInput): Promise<ShiftEmployeeSelfProfile> {
    return requestJson<ShiftEmployeeSelfProfile>('/shift/employees/me', {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }
}

export const shiftEmployeesService = new ShiftEmployeesService();
